import { render, staticRenderFns } from "./StockReservation.vue?vue&type=template&id=361f035f"
import script from "./StockReservation.vue?vue&type=script&lang=js"
export * from "./StockReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('361f035f')) {
      api.createRecord('361f035f', component.options)
    } else {
      api.reload('361f035f', component.options)
    }
    module.hot.accept("./StockReservation.vue?vue&type=template&id=361f035f", function () {
      api.rerender('361f035f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockReservation.vue"
export default component.exports